<template>
  <div class="d-flex justify-space-between">
    <div class="d-flex align-center">
      <ClosdFildersIcon :document="file"
                        :signed-file="itemIsSignedOnClosd"
                        class="mr-1"
      />

      <div>
        <span class="ma-0 text--small text-text-secondary">
          {{ file.name }}
          <app-filesize-display :value="file.size" class="ml-2 text-text-placeholder"/>
        </span>
      </div>
    </div>

    <app-button
      type="icon"
      @click="$emit('delete-file', file)"
    >
      <app-material-icon name="delete" />
    </app-button>
  </div>
</template>

<script>
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'

export default {
  name: 'ArchivesUploadedFileListItem',
  components: { ClosdFildersIcon },
  emits: ['delete-file'],
  props: {
    file: {
      type: [File, Object],
      required: true,
    },
  },
  computed: {
    itemIsSignedOnClosd () {
      return this.file.signedOnClosd
    },
  },
}
</script>
